import { Component, OnInit, ViewChild } from "@angular/core";
import {
  ToastController,
  LoadingController,
  ModalController,
  AlertController,
  IonInfiniteScroll,
} from "@ionic/angular";
import { InventoryService } from "../../api/inventory.service";
import { AppSettings } from "src/app/app-settings";
import { InventoryItemPage } from "./inventory-item/inventory-item.page";

import { DatatableComponent } from "@swimlane/ngx-datatable";
import { UploadModalComponent } from "src/app/components/upload-modal/upload-modal.component";

@Component({
  selector: "app-inventory",
  templateUrl: "./inventory.page.html",
  styleUrls: ["./inventory.page.scss"],
})
export class InventoryPage {
  @ViewChild(DatatableComponent) table: DatatableComponent;

  public rows: any[] = [];
  public cols: any[] = [];
  public sorts: any[];
  public lastActionDate: string = "";
  public page: any;
  public isLoading: boolean = false;
  public errors: any = [];
  public mobileSortSymbols: any;

  isWeb = AppSettings.IS_WEB;

  constructor(
    private modalController: ModalController,
    private alertCtrl: AlertController,
    private inventoryService: InventoryService,
    public toastCtrl: ToastController,
    public loadingController: LoadingController
  ) {
    this.page = {
      totalElements: 0,
      pageNumber: 1,
      size: 20,
      maxPage: 1,
    };

    this.mobileSortSymbols = {
      part_number: "/",
      manufacturer: "/",
      condition: "/",
      quantity: '/'
    };
  }
  async ionViewWillEnter() {
    this.getInventory(1, {}, []);
  }
  onSort(event) {
    this.sorts = event.sorts.map((o) => {
      return { col: o.prop, order: o.dir };
    });
    this.getInventory(1, {}, this.sorts);
  }
  async getInventory(page, filters, sorts = [], refresh_event = null) {
    this.isLoading = !refresh_event;

    // Display a loading modal on mobile app
    if (!this.isWeb && this.isLoading) {
      let loader = await this.loadingController.create({
        message: "Loading...",
      });
      loader.present();
    }

    let _this = this;
    this.inventoryService
      .list(page, filters, sorts)
      .then((r) => {
        _this.rows = r["results"];

        _this.page.totalElements = r["count"];
        _this.page.maxPage = Math.ceil(
          _this.page.totalElements / _this.page.size
        );
        if (r["last_updated"]) _this.lastActionDate = r["last_updated"];
        let temp_cols = [];
        for (var el in _this.rows[0])
          if (el != "id")
            temp_cols.push({ name: el.replace("_", " "), prop: el });
        _this.cols = temp_cols;
        this.isLoading = false;
      })
      .catch(async (err) => {
        _this.page.pageNumber = 1;
        if (err.error.error == "Invalid page") {
          _this.page.pageNumber = 1;
          _this.getInventory(1, filters, sorts);
        } else {
          _this.rows = [];
        }

        const toast = await this.toastCtrl.create({
          message: err.error.error,
          duration: 3000,
          position: "bottom",
          showCloseButton: true,
          color: "warning",
        });
        _this.isLoading = false;
        toast.present();
      })
      .finally(() => {
        _this.loadingController.dismiss().catch((_) => { });
        if (!!refresh_event) {
          refresh_event.target.complete();
        }
      });
  }
  async openDetailsModal(event, id = undefined) {
    if (event.type == "click") {
      if (!id) {
        id = event["row"].id;
      }

      const modal = await this.modalController.create({
        component: InventoryItemPage,
        componentProps: {
          inventoryItemId: id,
        },
        cssClass: !this.isWeb ? "modal-fullscreen" : "",
      });
      return await modal.present();
    }
  }
  async handleRowModalShow() {
    // const modalElement = await this.modalCtrl.create({
    //   component: InventoryPage
    // });
    // await modalElement.present();
  }
  async handlePurgeData() {
    let alert = await this.alertCtrl.create({
      header: "Are you sure you want to purge all your inventory's data ?",
      message: "All your inventory's data will be lost.",
      buttons: [
        {
          text: "No, Cancel !",
          role: "cancel",
          cssClass: "cancelAlert",
        },
        {
          text: "Yes, I'm sure",
          cssClass: "validateClose",
          handler: async () => {
            let loading = await this.loadingController.create({
              message: "We are deleting your inventory file, please wait...",
            });
            await loading.present();

            this.inventoryService
              .purge()
              .then(async (r) => {
                loading.dismiss();
                this.toastCtrl.dismiss().catch((_) => { });
                const toast = await this.toastCtrl.create({
                  message: "Your inventory file has been deleted",
                  duration: 3000,
                  position: "bottom",
                  showCloseButton: true,
                  color: "light",
                });
                toast.present();
                this.lastActionDate = "";
                this.page.offset = 0;
                this.getInventory(1, {});
              })
              .catch(async (r) => {
                loading.dismiss();
                const toast = await this.toastCtrl.create({
                  message: r.error.error,
                  duration: 3000,
                  position: "bottom",
                  showCloseButton: true,
                  color: "warning",
                });
                toast.present();
              });
          },
        },
      ],
    });
    await alert.present();
  }
  async handleUploadFileClick() {
    if (!AppSettings.IS_WEB) {
      const toast = await this.toastCtrl.create({
        message:
          "This action is not available in mobile version of our application.",
        duration: 3000,
        position: "bottom",
        showCloseButton: true,
        color: "warning",
      });
      toast.present();
    } else {
      document.getElementById("fileInput").click();
    }
  }

  async handleFileChange(event) {
    const alert = await this.alertCtrl.create({
      header: 'Are you sure you want to upload this inventory file?',
      message: "Your selected inventory file will be imported.",
      buttons: [
        {
          text: "No, Cancel !",
          role: "cancel",
          cssClass: "cancelAlert",
          handler: () => {
            event.target.value = ""; 
          }, 
        },
        {
          text: "Yes, I'm sure",
          cssClass: "validateClose",
          handler: async () => {
            let files = event.target.files;
            if (files.length <= 0) return;
            let _ = this;
            let loading = await this.loadingController.create({
              message: "We are importing your inventory file, please wait...",
            });
            await loading.present();
            this.inventoryService
              .import(files[0])
              .then(async (r) => {
                event.srcElement.value = "";
                loading.dismiss();
                this.errors = [];
                let message =
                  "Your inventory file has been imported (" +
                  r["total_inserted"] +
                  (r["total_inserted"] > 1 ? " entries inserted)" : " entry inserted)");
                if (r && r["invalid_entries"]) {
                  let message = r["invalid_entries"].length + " invalid entr";
                  message +=
                    r["invalid_entries"].length == 1
                      ? "y has not been inserted"
                      : "ies have not been inserted";
                  this.errors = [
                    {
                      title: message,
                      body: r["invalid_entries"],
                    },
                  ];
                }

                this.toastCtrl.dismiss().catch((_) => { });
                const toast = await this.toastCtrl.create({
                  message: message,
                  duration: 3500,
                  position: "bottom",
                  showCloseButton: true,
                  color: "light",
                });
                toast.present();
                _.page.pageNumber = 1;
                _.page.offset = 0;
                if (_.isWeb) {
                  _.table.offset = 0;
                }
                _.getInventory(1, {});
              })
              .catch(async (r) => {
                event.srcElement.value = "";
                loading.dismiss();
                if (r.error && r.error.error) {
                  this.toastCtrl.dismiss().catch((_) => { });
                  const toast = await this.toastCtrl.create({
                    message: r.error.error,
                    duration: 8000,
                    position: "bottom",
                    showCloseButton: true,
                    color: "warning",
                  });
                  toast.present();
                } else {
                  const toast = await this.toastCtrl.create({
                    message: "Something went wrong. Please try again later.",
                    duration: 3000,
                    position: "bottom",
                    showCloseButton: true,
                    color: "warning",
                  });
                  toast.present();
                }
              });
          },
        },
      ],
    });
    await alert.present();
  }

  async inform() {
    let alert = await this.alertCtrl.create({
      message:
        "You can only see your inventory from the mobile app. Use the web app to delete or import your inventory.",
      buttons: [
        {
          text: "Ok",
          role: "cancel",
        },
      ],
    });
    await alert.present();
  }
  sortMobile(parameter) {
    this.mobileSortSymbols[parameter] = this.nextMobileSort(
      this.mobileSortSymbols[parameter]
    );
    this.page.pageNumber = 1;
    this.sorts = [];
    for (let column in this.mobileSortSymbols) {
      if (this.mobileSortSymbols[column] == "+") {
        this.sorts.push({ col: column, order: "asc" });
      }

      if (this.mobileSortSymbols[column] == "-") {
        this.sorts.push({ col: column, order: "desc" });
      }
    }
    this.getInventory(this.page.pageNumber, {}, this.sorts);
  }
  nextMobileSort(symbol) {
    if (symbol == "/") {
      return "+";
    } else if (symbol == "+") {
      return "-";
    } else {
      return "/";
    }
  }
  doRefresh(event) {
    let _this = this;
    setTimeout(() => {
      _this.page.pageNumber = 1;
      _this.mobileSortSymbols = {
        part_number: "/",
        manufacturer: "/",
        condition: "/",
      };
      _this.getInventory(1, {}, [], event);
    }, 0);
  }

  async uploadModal() {
    const modal = await this.modalController.create({
      component: UploadModalComponent,
    });

    await modal.present();
  }
}
